import { Chip } from "@mui/material";
import { useUrlSelectLayer } from "hooks/layerSetHooks";
import { Layer } from "types/types";

interface Props {
  layer: Layer;
  layerList: Layer[];
}

export function LayerSetDialogTag(props: Props) {
  const { layer, layerList } = props;
  const { selectedLayer, selectLayer } = useUrlSelectLayer(layerList);

  return (
    <Chip
      label={layer.uniqueName}
      color={selectedLayer.id === layer.id ? "primary" : "default"}
      onClick={() => selectLayer(layer.id)}
    />
  );
}
